import React from 'react';

const About = () => {
  return (
    <div className='p-5 lg:p-10 bg-darkest lg:px-36 lg:h-96'>
      <h3 class='text-black mb-4 text-4xl font-bold lg:text-left md:text-center lg:pl-12'>
        Who We Are
      </h3>
      <div className='bg-lightest p-6 rounded-lg shadow-lg text-left'>
        <p className='font-normal text-gray-700 dark:text-gray-400'>
          Link and Learn offers 100% customized therapy and private academic
          lessons directly at students’ homes to support clients and their
          families. As an official business partner of Alberta’s Family Supports
          for Children with Disabilities (FSCD) program, our therapy programs
          are ideal for students with autism, ADHD and other neurological
          differences. Link and Learn’s custom tailored academic lessons are
          perfect for students of all ages and levels, especially those with
          special needs and students seeking accelerated learning. Our academic
          and therapeutic teams work holistically to maximize your child’s
          potential while catering all sessions specifically to a student’s
          needs and persona. Book your complimentary holistic assessment today!{' '}
        </p>
      </div>
    </div>
  );
};

export default About;
